// extracted by mini-css-extract-plugin
module.exports = {"flex-row":"Current_flex-row__18yAn","edit-icon":"Current_edit-icon__1njvn"};